import { useAuthContext } from 'hooks/useAuthContext';
import React, { useEffect } from 'react';

import {  useHistory } from 'react-router-dom';
import {
  Header,
  HeaderTextWrapper,
  Logo,
  HeaderTitle,
  HeaderText,
  Infographic,

} from './elements';
import { useClickStreamContext } from '../ClickStream';
import LoginForm from './LoginForm';
import LoginLayout from './layout';

const Login = () => {
  const { userData } = useAuthContext();
  const { logPageEvent, logViewPage } = useClickStreamContext();
  const location = useHistory();
  useEffect(() => {
    logViewPage?.({});
    logPageEvent({
      eventType: 'open_login_page',
      eventInfo: `Вход на страницу логина`,
      eventSource: 'login_municipality',
    });

    if (userData !== null) {
      location.push('/');
    }
  }, []);

  return (
    <LoginLayout>
      <Header>
        <HeaderTextWrapper>
          <Logo />
          <HeaderTitle>
            Кабинет региона <br />и муниципалитета
          </HeaderTitle>
          <HeaderText>Удобный способ отслеживать внедрение цифровой платформы Учи.ру в школы</HeaderText>
          <Infographic />
        </HeaderTextWrapper>
        <LoginForm />
      </Header>
    </LoginLayout>
  );
};

export default Login;
